// Configuration for API endpoints and frontend URLs used across the application.

export const IS_DEV = process.env.REACT_APP_NODE_ENV === "development";

export const API_URL = process.env.REACT_APP_API_URL;

// in development iam frontend url will be localhost else will be applab
export let IAM_FRONT_END_URL = process.env.REACT_APP_IAM_URL;
export const VIEWER_URL = process.env.REACT_APP_VIEWER_URL;
//export const REMOTE_CONTROL_URL = VIEWER_URL + "/remote-control";
export const REMOTE_CONTROL_URL = process.env.REACT_APP_REMOTE_CONTROL_URL;
export const DIAGNOSTIC_TOOL_URL = VIEWER_URL + "/diagnostic-tools";
if (IS_DEV) {
  IAM_FRONT_END_URL =
    IAM_FRONT_END_URL + `:${process.env.REACT_APP_IAM_FRONT_END_PORT}`;
}
// this is for the patch microservice
//TODO:This is made for the development call only and the porduction should be updated
export const Patch_API_URL = process.env.REACT_APP_PATCH_API_URL;

//will be applab for iam api
export const IAM_API_URL = process.env.REACT_APP_IAM_API_URL;
export const PATCHMANAGEMENT_API_URL =
  process.env.REACT_APP_PATCHMANAGEMENT_API_URL;

export const PUBLIC_URL = new URL(process.env.PUBLIC_URL, window.location.href);
export const DEFAULT_LOGO_URL = PUBLIC_URL + "/ZecuritLogo.svg";
export const DEFAULT_FAVICON_URL = PUBLIC_URL + "/favicon.ico";
export const IMAGE_URL = API_URL + "/UM/getImage";

const pathSegments = new URL(window.location.href).pathname.split("/");
const appType = pathSegments[1];

let productMap = {
  em: 5,
  am: 4,
  ra: 2,
  "em-msp": 6,
  vm: 7,
  pm: 8,
};

// Replaced the '??' operator with a safe ternary condition
export const PRODUCT_ID =
  productMap[appType] !== undefined ? productMap[appType] : null;
export const PRODUCT_CONTEXT = appType;
export let IS_MSP = appType.includes("msp");
//IS_MSP=true;

export function buildUrl(baseUrl, url, productId) {
  // Construct a full URL object
  const full = new URL(`${baseUrl}/${url}`, window.location.origin);

  // Add or overwrite productId param
  full.searchParams.set("productId", productId);

  return full.toString();
}

export function getProductIdByContext(context) {
  return productMap[context] !== undefined ? productMap[context] : null;
}

const ENV_MAP = {
  localhost: "LOCAL",
  "applab.zecurit.com": "LAB",
  "app.zecurit.com": "PRODUCTION",
};

const getCurrentEnv = () => {
  const host = window.location.hostname.toLowerCase();
  return ENV_MAP[host];
};

export const isLocalhost = () => getCurrentEnv() === "LOCAL";
export const isProduction = () => getCurrentEnv() === "PRODUCTION";
export const isLab = () => getCurrentEnv() === "LAB";
